import { AulaDispatch } from '@core/types/state';
import { INBOX_CHANGE_CONVERSATION_OPEN } from '../actions';

const changeConversationOpen =
  (newValue: boolean) => (dispatch: AulaDispatch) => {
    dispatch({
      type: INBOX_CHANGE_CONVERSATION_OPEN,
      payload: newValue,
    });
  };

export default changeConversationOpen;
